var _style, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "s_twitter",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t\t\t\t\t\t\t.st2{fill:#a9c5d7;}\r\n\t\t\t\t\t\t\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2153_206)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.2357 8.89475L19.8877 0H18.0744L11.4302 7.72319L6.12356 0H0.00292969L8.02767 11.6788L0.00292969 21.0063H1.8163L8.83271 12.8504L14.437 21.0063H20.5576L12.2353 8.89475H12.2357ZM9.75208 11.7817L8.93901 10.6188L2.46968 1.36507H5.2549L10.4757 8.8331L11.2888 9.99605L18.0753 19.7033H15.29L9.75208 11.7822V11.7817Z",
    fill: "#a9c5d7",
    stroke: "#a9c5d7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2153_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5546,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f3c5ff336fda6cdc90023c95c68c4c08.svg";
export { ForwardRef as ReactComponent };